import { Model } from './model';
import { Type } from 'class-transformer';
import { DeductionCreditMemoLineItem } from './deduction_credit_memo_line_item';
import { sumArray } from '@stuut/common/src/utils';
import { TransformStringToDayJS } from './utils';
import dayjs from 'dayjs';

interface CreditMemoPartner {
  id: string;
  name: string;
}

export enum CreditMemoCreationSource {
  REMOTE = 'remote',
  DEDUCTIONS = 'deductions',
}

export class DeductionCreditMemo extends Model {
  id: string;

  currency: string;

  allowance_reference: string | null;

  applied_amount: number;

  customer_reference: string | null;

  gross_amount: number;

  net_amount: number;

  tax_amount: number;

  discount_amount: number;

  @TransformStringToDayJS()
  due_date: dayjs.Dayjs | null;

  @TransformStringToDayJS()
  date: dayjs.Dayjs | null;

  document_number: string | null;

  number: string | null;

  erp_link: string | null;

  is_updating: boolean;

  is_synced: boolean;

  remote_id: string;

  creation_source: CreditMemoCreationSource;

  @TransformStringToDayJS()
  posted_date: dayjs.Dayjs | null;

  @Type(() => DeductionCreditMemoLineItem)
  line_items: DeductionCreditMemoLineItem[];

  partner_id: string;

  partner: CreditMemoPartner;
}
